/** 上报埋点元素 */
import beaconReport from '@utils/beacon';
import React, {
  createElement,
  forwardRef,
  useRef,
  useCallback,
  useEffect,
  useImperativeHandle,
} from 'react';

interface IProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  /** 曝光埋点 */
  code_explore?: string;
  /** cv埋点 */
  code_click?: string;
  element?: string | React.ElementType;
  onClick?(...args: any): any;
  [key: string]: any;
}
const ReportElement = forwardRef<any, IProps>(
  ({ code_explore, code_click: click_code, element = 'div', onClick, ...others }, ref) => {
    useEffect(() => {
      if (!code_explore) return;
      beaconReport(code_explore);
    }, [code_explore]);

    const click = useCallback(
      (...args: any) => {
        beaconReport(click_code);
        return onClick?.(...args);
      },
      [onClick, click_code],
    );

    // 防止外部传入 ref 报错
    const childRef = useRef<any>();
    useImperativeHandle(ref, () => childRef.current);

    return createElement(element, { ...others, onClick: click, ref: childRef });
  },
);

ReportElement.displayName = 'ReportElement';

export default ReportElement;
